import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Card,
  CardContent,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  oauthUserMgmt,
  tenant,
  headers,
  loginMemberId,
  systemConfig,
} from "../../utils/utils";

const Invite = () => {
  const [requestStatus, setRequestStatus] = useState(""); // 'idle', 'sending', 'sent'
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllMember = useCallback(async () => {
    const tenantValue = tenant();
    const headers = oauthUserMgmt();

    const response = await fetch(
      `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?q=tenant:${tenantValue}`,
      {
        method: "GET",
        headers: headers,
      },
    );

    if (response.ok) {
      const result = await response.json();

      const usersWithFullNameAndId = result
        ? result
            .filter((item) => item.firstName)
            .map((user) => ({
              id: user.id,
              email: user.email,
              firstName: user.firstName,
              lastName: user.lastName,
              roles: [],
            }))
        : [];

      const usersWithRoles = await Promise.all(
        usersWithFullNameAndId.map(async (user) => {
          const rolesResponse = await fetch(
            `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users/${user.id}/role-mappings/realm`,
            {
              method: "GET",
              headers: headers,
            },
          );

          if (rolesResponse.ok) {
            const roles = await rolesResponse.json();
            return {
              ...user,
              roles: roles.map((role) => role.name),
            };
          }

          return user;
        }),
      );

      setUsers((prevUsers) => [...prevUsers, ...usersWithRoles]);
    }
  }, []); // ✅ Removed unnecessary dependencies

  useEffect(() => {
    fetchAllMember();
  }, [fetchAllMember]); // ✅ Safe to call `fetchAllMember`

  const handleRequestAccess = async () => {
    console.log("USER", users);

    const adminUsers = users.filter((user) => user.roles.includes("ADMIN"));
    const adminEmails = adminUsers.map((adminUser) => adminUser.email);
    // const adminEmails = ["nagaraj.s@vyoog.com", "deebika.k@vyoog.com"];
    console.log("Admin Emails:", adminEmails);
    // Set status to 'sending' to show a loading spinner and message
    // setRequestStatus('sending');
    setLoading(true);
    try {
      // Simulate an API request (replace this with your actual API call)
      const boardConfig = await systemConfig(localStorage.getItem("board"));
      if (!boardConfig || !boardConfig.groupName) {
        console.error("groupName is missing in the response", boardConfig);
        return;
      }

      const board = boardConfig.value;
      console.log("board", board);
      // await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await fetch(
        process.env.REACT_APP_TICKET_SERVER + "/ticket/boardRequest",
        {
          method: "POST",
          headers: headers(),
          body: JSON.stringify({
            adminEmails: adminEmails.join(","),
            boardId: localStorage.getItem("board"),
            board: board,
            requestId: loginMemberId(), // Password provided by the user
            requestUserName: localStorage.getItem("vyg_login_user"), // Set to true if you want the user to reset the password on first login
          }),
        },
      );

      if (response.ok) {
        setRequestStatus("sent");
        setLoading(false);
      } else {
        setRequestStatus("error");
        setLoading(false);
      }

      // Update status to 'sent' when the request is successful
    } catch (error) {
      // Handle error case (you can show an error message here)
      console.error("Error sending request:", error);
      setRequestStatus("error");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f5f5"
    >
      <Card
        sx={{
          maxWidth: 400,
          padding: 3,
          textAlign: "center",
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <CardContent>
          {requestStatus === "idle" || requestStatus === "" ? (
            <>
              <Typography variant="h6" color="error" gutterBottom>
                You don't have access to this board
              </Typography>
              <Typography variant="body1" color="text.secondary" mb={2}>
                Please click below to request access.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleRequestAccess}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Request Access"
                )}
              </Button>
            </>
          ) : requestStatus === "sending" ? (
            <>
              <CircularProgress size={24} />
              <Typography variant="body1" color="text.secondary" mt={2}>
                Sending request...
              </Typography>
            </>
          ) : requestStatus === "sent" ? (
            <>
              <Typography variant="h6" color="success.main" gutterBottom>
                Request Sent Successfully
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Your request has been sent. Please wait for approval.
              </Typography>
            </>
          ) : requestStatus === "error" ? (
            <>
              <Typography variant="h6" color="error.main" gutterBottom>
                Error Sending Request
              </Typography>
              <Typography variant="body1" color="text.secondary">
                There was an issue sending your request. Please try again.
              </Typography>
            </>
          ) : null}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Invite;
